import React from "react";
import styled from "styled-components";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"

import '@leenguyen/react-flip-clock-countdown/dist/index.css';

const ContainerStyled = styled.div`
    max-width: 1400px;
    width: 100%;

    @media ${media.xl} {
        position: absolute;
        z-index: 10;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
`

const CountDownStyles = styled.div`
    width: 100%;
    background: #0D1230;
    padding: 2rem 0;
    text-align: center;

    @media ${media.md} {
        padding: 3rem 0;
    }

    @media ${media.xl} {
        position: absolute;
        top: 0;
        left: 4rem;
        background: rgba(13, 18, 48 , 0.35);
        width: 500px;
        padding: 2rem 0 1.5rem 0;
    }

    .inner {
        width: 91%;
        margin: 0 auto;
        p {
            color: #fff;
            font-weight: 900;
            text-transform: uppercase;
            font-size: 15px;
            font-family: ${props => props.theme.font.family.atp};
            letter-spacing: 0.28px;
            @media ${media.sm} {
                font-size: 20px;
            }
            @media ${media.md} {
                margin-bottom: 1.5rem;
            }
        }
        .button {
            margin-top: 1rem;
            @media ${media.md} {
                margin-top: 1.5rem;
            }
            a {
                padding: 0.75rem 2rem;
                border-radius: 5px;
                font-family: GothamNarrowBold;
            }
        }
    }
    .countdown {
        margin: 0 auto;
        text-align: center;
        justify-content: center;
        div:nth-of-type(6) {
            display: none!important;
        }
        ._2v-d4 {
            /* background: white; */
        }

        .fcc__digit_block {
            @media ${media.sm} {
                font-size: 40px;
            }
        }
        
        .fcc__label {
            font-size: 14px;
            font-weight: 900!important;
            font-family: ${props => props.theme.font.family.atp};
            @media ${media.md} {
                font-size: 18px!important;
            }
        }
    }
   .fcc__unit_time--second {
        display: none;
   }
`

export default function CountDown({ value, button }) {
    return (
        <ContainerStyled>
            <CountDownStyles>
                <div className="inner">
                    <p>Countdown to the chevron championship</p>
                    <div>
                        <FlipClockCountdown
                            to={value}
                            // to={new Date().getTime() + 24 * 3600 * 1000 + 5000}
                            labels={['DAYS', 'HOURS', 'MINUTES']}
                            renderMap={[true, true, true, false]}
                            labelStyle={{ fontSize: 16, fontWeight: 500, color: '#009FE3', fontWeight: '900', textTransform: 'uppercase' }}
                            digitBlockStyle={{ width: 40, height: 60, fontSize: 40, background: 'white', color: '#0C2D71', fontFamily: 'GothamNarrowBold' }}
                            dividerStyle={{ color: 'white', height: 0 }}
                            separatorStyle={{ color: 'white', size: '6px' }}
                            duration={0.5}
                            className="countdown"
                        >
                            <span>Finished</span>
                        </FlipClockCountdown>
                    </div>
                    {button && (
                        <div className="button">
                            <WPLink url={button.url} target={button.target} button color="secondary">
                                {button.title}
                            </WPLink>
                        </div>
                    )}
                </div>
            </CountDownStyles>
        </ContainerStyled>
    );
}